<template>
    <v-container class="container">
        <v-card>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-toolbar dark dense color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text">Truck Form
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-tabs centered>
                    <v-tab v-if="$store.state.roles != 'Accounting'">General Information</v-tab>
                    <v-tab v-if="$store.state.roles != 'Accounting'">Financial Information</v-tab>
                    <v-tab v-if="$store.state.roles == 'Accounting' || $store.state.roles == 'Administrator'">Accouting Information</v-tab>
                    <v-tab-item class="mx-5" v-if="$store.state.roles != 'Accounting'">
                        <v-row justify="center">
                            <v-col cols="4">
                                <v-text-field label="Truck Name" v-model="editedItem.Truck" required :rules="[
                                    v => !!v || 'Truck Name is required']"></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <v-text-field label="Truck Year" v-model="editedItem.TruckYear" placeholder="yyyy-mm-dd" v-mask="'####/##/##'"></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <v-text-field
                                    label="GeotabID"
                                    v-model="editedItem.TruckGeotabID"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="2">
                                <v-combobox v-model="editedItem.Yard" :items="yards" :item-text="'Yard'" :item-value="'id'"
                                    label="Yard" :rules="[v => !!v || 'Yard is required']" auto-select-first></v-combobox>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field label="Registered Gross Vehicle Weight"
                                    v-model="editedItem.RGVW"></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-combobox
                                    placeholder="Select Company"
                                    class="mx-3"
                                    v-model="company"
                                    :items="companies"
                                    required
                                    :rules="[v => !!v || 'Required']"
                                    :item-text="'Company'"
                                    :item-value="'CompanyId'"
                                    auto-select-first
                                    @change="changeCompanyTruck"
                                >
                                </v-combobox>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="2">
                                <v-text-field label="Axle Quantity" v-model="editedItem.NumAxles" :rules="[
                                    v => !!v || 'Axle Quantity is required'
                                ]"></v-text-field>
                            </v-col>
                            <!-- <v-col cols="2">
                                <v-text-field
                                    label="Truck Type Code"
                                    v-model="editedItem.TruckType"
                                ></v-text-field>
                            </v-col> -->
                            <v-col cols="2">
                                <v-text-field label="Owner Operator Code" v-model="editedItem.OOID"></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field label="Alias" v-model="editedItem.Alias"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" style="width: 1200px; margin: 0 auto;">
                            <v-col cols="12" md="2">
                                <v-switch label="Has Pump" v-model="editedItem.Pump" input-value="true"></v-switch>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-switch label="Has Bunk" v-model="editedItem.Bunk" input-value="true"></v-switch>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-switch label="Out Service" v-model="editedItem.OutService" input-value="true"></v-switch>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-combobox v-model="type" @change="changeTypeTruck" :items="types" :item-text="'Type'"
                                    :item-value="'TruckTypeId'" label="Truck Type" :rules="[v => !!v || 'Yard is required']"
                                    auto-select-first></v-combobox>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item class="mx-5" v-if="$store.state.roles != 'Accounting'">
                        <v-row justify="center">
                            <v-col cols="3">
                                <v-text-field label="Split Charge" v-model="editedItem.SplitCharge"
                                    prepend-inner-icon="mdi-currency-usd"></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field label="Split Terminal Charge" v-model="editedItem.SplitChargeTerminal"
                                    prepend-inner-icon="mdi-currency-usd"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="3">
                                <v-text-field label="Maintenance Cost" v-model="editedItem.MaintenanceCost"
                                    prepend-inner-icon="mdi-currency-usd"></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field label="Lease Cost" v-model="editedItem.LeaseCost"
                                    prepend-inner-icon="mdi-currency-usd"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="3">
                                <v-text-field label="Insurance Cost" v-model="editedItem.InsuranceCost"
                                    prepend-inner-icon="mdi-currency-usd"></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field label="License Cost" v-model="editedItem.LicenceCost"
                                    prepend-inner-icon="mdi-currency-usd"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item v-if="$store.state.roles == 'Accounting' || $store.state.roles == 'Administrator'">
                        <v-row justify="center">
                            <v-col cols="3">
                                <v-text-field label="AdminFee" v-model="editedItem.AdminFee"
                                    prepend-inner-icon="mdi-currency-usd"></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field label="Holdback" v-model="editedItem.Holdback"
                                    prepend-inner-icon="mdi-currency-usd"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="3">
                                <v-text-field label="Maint Holdback" v-model="editedItem.MaintHoldback"
                                    prepend-inner-icon="mdi-currency-usd"></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field label="Parking" v-model="editedItem.Parking"
                                    prepend-inner-icon="mdi-currency-usd"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-card>
                            <v-toolbar dark dense color="secondary">
                                <v-spacer></v-spacer>
                                <v-toolbar-title class="white--text">Longterm Leasing
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-container grid-list-xs fluid>
                                <v-row justify="center" class="mt-6">
                                    <v-col cols="2">
                                        <v-text-field label="RentalTruck" v-model="editedItem.RentalTruck" dense
                                            hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-text-field  type="number" label="Amount" @change="calculateHST" v-model="editedItem.AmountTruck" dense
                                            hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-text-field     type="number" label="HSTTruck"  v-model="editedItem.HSTTruck" dense
                                            hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-chip label>{{ Number(Number(editedItem.AmountTruck) + Number(editedItem.HSTTruck)).toFixed(2)  }}</v-chip>
                                    </v-col>
                                </v-row>
                                <v-row justify="center">
                                    <v-col cols="3">
                                        <v-text-field placeholder="yyyy-mm-dd" v-mask="'####/##/##'"
                                            label="Efective Date Start" v-model="editedItem.EfectiveDateStart" dense
                                            hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field placeholder="yyyy-mm-dd" v-mask="'####/##/##'"
                                            label="Efective Date End" v-model="editedItem.EfectiveDateEnd" dense
                                            hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-tab-item>

                </v-tabs>
                <v-container>
                    <v-row justify="end">
                        <v-btn dark color="secondary" class="mx-5 white--text" @click="validate()">
                            Save
                            <v-icon right dark>mdi-content-save</v-icon>
                        </v-btn>
                        <v-btn exact dark color="secondary" class="mr-5 white--text" :to="'/catalogs/trucks'">
                            Close
                            <v-icon right dark>mdi-close</v-icon>
                        </v-btn>
                    </v-row>
                </v-container>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    directives: { mask },
    name: 'TrucksForm',
    data() {
        return {
            truckID: 0,
            expenses: [],
            headers: [
                { text: 'RentalTruck', value: 'RentalTruck', width: '20%' },
                { text: 'Amount', value: 'Amount', width: '20%' },
                { text: 'EfectiveDateStart', value: 'EfectiveDateStart', width: '30%' },
                { text: 'EfectiveDateEnd', value: 'EfectiveDateEnd', width: '30%' },
            ],
            editedItem: {
                Truck: null,
                Alias: null,
                OOID: null,
                Yard: null,
                RGVW: null,
                TruckType: null,
                NumAxles: null,
                Pump: null,
                Bunk: null,
                SplitCharge: null,
                SplitChargeTerminal: null,
                MaintenanceCost: null,
                LeaseCost: null,
                InsuranceCost: null,
                LicenceCost: null,
                Active: null,
                OutService: null,
                RentalTruck: null,
                EfectiveDateEnd: null,
                EfectiveDateStart: null,
                AmountTruck: 0,
                AdminFee: null,
                Holdback: null,
                MaintHoldback: null,
                Parking: null,
                HSTTruck: 0,
                TruckGeotabID: '',
            },
            companies:[],
            types: [],
            yards: [],
            type: [],
            valid: true
        };
    },
    async mounted() {
        await this.loadCompanies();
        this.loadYards();
        await this.loadTruckType();
    },
    methods: {
        calculateHST: function(){
            this.editedItem.HSTTruck = Number(this.editedItem.AmountTruck * .13) ;
        },
        loadCompanies: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('oo-company', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.companies = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        saveExtExpense: function () {
            var parms = {
                TruckId: this.truckID,
                RentalTruck: this.RentalTruck,
                AmountTruck: this.AmountTruck,
                EfectiveDateEnd: this.EfectiveDateEnd,
                EfectiveDateStart: this.EfectiveDateStart,
            };
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('ext-expense', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.loadExpType();
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text:
                            'Successfully saved'
                    });
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        changeTypeTruck: function () {
            this.editedItem.TruckType = this.type.TruckTypeId;
        },
        changeCompanyTruck: function () {
            this.editedItem.Company = this.company.CompanyId;
        },
        loadExpType: function () {
            var str = this.$store;
            str.state.isLoading = true;
            var params = {
                Truck: this.truckID
            }
            axios
                .post('ext-expense/truck', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.expenses = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    this.$store.state.isLoading = false;
                });
        },
        loadTruckType: function () {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('truck/type-truck', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.types = response.data;
                    this.$store.state.isLoading = false;
                    this.loadTruckData();
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    this.$store.state.isLoading = false;
                });
        },
        loadTruckData: function () {
            this.truckID = this.$store.state.editedTruck.id;
            this.loadExpType();
            var str = this.$store;
            if (this.truckID != 0) {
                this.$store.state.isLoading = true;
                axios
                    .get('truck/' + this.truckID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.editedItem = Object.assign(
                            {},
                            response.data.data[0]
                        );
                        console.log(this.editedItem);
                        this.$store.state.editedTruck.id = 0;
                        this.editedItem.Yard = {
                            id: response.data.data[0].YardID,
                            Yard: response.data.data[0].Yard
                        };
                        const indx = this.types.findIndex(elm => {
                            return elm.TruckTypeId == response.data.data[0].TruckType;
                        });

                        const idx = this.companies.findIndex(elm => {
                            return elm.CompanyId == response.data.data[0].Company;
                        });
                        console.log("Here",idx);
                        this.company = this.companies[idx];
                        this.type = this.types[indx];
                        this.$store.state.isLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                        this.$store.state.isLoading = false;
                    });
            }
        },
        newTruck: function () {
            console.log(this.editedItem);
            this.$store.state.isLoading = true;
            var str = this.$store;
            console.log(this.editedItem);
            this.editedItem.Yard = this.editedItem.Yard.id;
            this.editedItem.Active = true;
            console.log(this.editedItem);

            str.state.isLoading = true;
            axios
                .post('truck', this.editedItem, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'New truck added.'
                    });
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.$router.push('/catalogs/trucks');
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        editTruck: function () {
            var str = this.$store;
            str.state.isLoading = true;
            if (this.editedItem.Yard != null) {
                this.editedItem.Yard = this.editedItem.Yard.id;
                delete this.editedItem.YardID;
                delete this.editedItem.id;
            }
            axios
                .put('truck/' + this.truckID, this.editedItem, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Truck information saved.'
                    });
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.$router.push('/catalogs/trucks');
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    str.state.isLoading = false;
                });
        },
        save: function () {
            if (this.truckID > 1) {
                this.editTruck();
            } else {
                this.newTruck();
            }
        },
        loadYards: function () {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('yard/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.yards = response.data.data;
                    this.$store.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    this.$store.state.isLoading = false;
                });
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.save();
            }
        }
    }
};
</script>
